import { createStoreApi } from './store-api.js';

// 確認した商品・数量・金額が送信直前にも同じかを比較する。
export function orderCartSignature(cart) {
  return JSON.stringify({
    items: cart.items.map(item => [item.key, item.quantity, item.prices, item.totals, item.variation]),
    totals: cart.totals,
  });
}

// 受付済みの本人の注文だけを完了扱いにし、移動先はテーマの設定値から作る。
export function checkoutResultUrl(order, settings, baseUrl) {
  if (!Number.isSafeInteger(order?.order_id) || order.order_id < 1
    || typeof order.order_key !== 'string' || !order.order_key
    || order.customer_id !== settings.customerId
    || !['on-hold', 'processing', 'completed'].includes(order.status)
    || order.payment_result?.payment_status !== 'success') return '';
  try {
    if (settings.isLineMember) {
      const url = new URL(settings.lineUrl);
      return url.protocol === 'https:' && url.hostname === 'line.me'
        && /^\/R\/oaMessage\/(?:%40|@)[a-z0-9._-]+$/i.test(url.pathname) ? url.href : '';
    }
    const url = new URL(settings.receivedUrl, baseUrl);
    if (url.origin !== new URL(baseUrl).origin) return '';
    url.searchParams.set('order_id', order.order_id);
    url.searchParams.set('key', order.order_key);
    return url.href;
  } catch { return ''; }
}

// 実カートを表示し、明示的な注文ボタン操作で標準checkoutへ一度だけ送る。
export function initOrderCheckout($) {
  const $panel = $('.js-order-confirm');
  const config = window.ueharaStore;
  if (!$panel.length || !config?.available || !config.checkout) return;
  const settings = config.checkout;
  const store = createStoreApi($, config);
  const $status = $('.js-order-status');
  const $submitStatus = $('.js-order-submit-status');
  const $submit = $('.js-order-submit');
  const $refresh = $('.js-order-refresh');
  const $notes = $('.js-order-notes');
  const storageKey = 'uehara-checkout-pending-' + settings.customerId;
  const unknownResult = '注文の受付結果を確認できませんでした。二重注文を防ぐため再送せず、お問い合わせください。';
  let cart = null;
  let busy = false;
  let cartBusy = false;
  let cartFailed = false;
  let pending = false;
  try { pending = window.sessionStorage.getItem(storageKey) === 'pending'; } catch { /* 保存不可でも、この画面内では再送を止める。 */ }

  function plain(value) {
    return new DOMParser().parseFromString(String(value || ''), 'text/html').body.textContent || '';
  }
  function money(value, totals) {
    return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: totals.currency_code })
      .format(Number(value) / 10 ** totals.currency_minor_unit);
  }
  function message($target, value, error = false) {
    $target.text(value).toggleClass('is-error', error);
  }
  function cartError(value) {
    if (!value.items.length) return '買い物袋に商品が入っていません。';
    if (value.errors?.length) return value.errors.map(error => plain(error.message)).join('\n');
    if (Number(value.totals.total_shipping) !== 0 || Number(value.totals.total_shipping_tax) !== 0) {
      return '送料の設定を確認する必要があります。お問い合わせください。';
    }
    if (settings.isLineMember && !settings.lineUrl) return 'LINEの移動先を確認できませんでした。時間をおいてページを読み直してください。';
    return '';
  }
  function updateControls() {
    $submit.prop('disabled', busy || cartBusy || cartFailed || pending || !cart || Boolean(cartError(cart)));
    $refresh.prop('disabled', busy || pending);
    $notes.prop('readOnly', busy || pending);
    $panel.attr('aria-busy', String(busy));
    $('.js-home-cart-open').prop('disabled', busy || pending);
    $('.js-order-contact').prop('hidden', busy || !(pending || cartFailed || (cart && cart.items.length && cartError(cart))));
  }
  function setPending(value) {
    pending = value;
    try {
      if (value) window.sessionStorage.setItem(storageKey, 'pending');
      else window.sessionStorage.removeItem(storageKey);
    } catch { /* 状態はメモリーにも保持する。 */ }
  }

  // サーバーの税抜小計・割引・手数料と消費税を分け、税込合計を表示する。
  function render(nextCart) {
    cart = nextCart;
    cartFailed = false;
    const error = cartError(cart);
    message($status, error, Boolean(error && cart.items.length));
    $('.js-order-cart').prop('hidden', !cart.items.length || Boolean(error));
    $refresh.prop('hidden', !error || !cart.items.length || pending);
    const $items = $('.js-order-items').empty();
    cart.items.forEach(function (item) {
      const $row = $('<tr>').appendTo($items);
      const $name = $('<td>', { class: 'p-order__product-name', text: plain(item.name) }).appendTo($row);
      (item.variation || []).forEach(function (variation) { $('<span>', { text: ' ' + plain(variation.value) }).appendTo($name); });
      $('<small>', { class: 'p-order__unit', text: money(item.prices.price, item.prices) + ' / 1kg' }).appendTo($name);
      $('<td>', { text: item.quantity }).appendTo($row);
      $('<td>', { text: money(Number(item.totals.line_total) + Number(item.totals.line_total_tax), item.totals) }).appendTo($row);
    });
    const totals = cart.totals;
    $('.js-order-subtotal').text(money(totals.total_items, totals));
    $('.js-order-total').text(money(totals.total_price, totals));
    $('.js-order-tax-row').prop('hidden', !settings.taxEnabled || Number(totals.total_tax) === 0);
    $('.js-order-tax').text(money(totals.total_tax, totals));
    const discount = Number(totals.total_discount);
    $('.js-order-discount-row').prop('hidden', discount === 0);
    $('.js-order-discount').text('−' + money(discount, totals));
    const fees = Number(totals.total_fees);
    $('.js-order-fees-row').prop('hidden', fees === 0);
    $('.js-order-fees').text(money(fees, totals));
    updateControls();
  }
  function readFailure(xhr) {
    cartFailed = true;
    message($status, plain(xhr.responseJSON?.message) || '買い物袋を読み込めませんでした。もう一度読み込んでください。', true);
    $refresh.prop('hidden', pending);
  }
  async function loadCart() {
    if (busy || pending) return;
    busy = true;
    updateControls();
    message($status, '買い物袋を読み込んでいます。');
    try { render(await store.cart()); }
    catch (xhr) { readFailure(xhr); }
    finally { busy = false; updateControls(); }
  }
  $refresh.on('click', loadCart);
  $(document).on('uehara:cart-updated', function (_event, nextCart) { if (!busy && !pending) render(nextCart); });
  $(document).on('uehara:cart-busy', function (_event, value) { cartBusy = value; updateControls(); });
  $(document).on('uehara:cart-failed', function () { cartFailed = true; updateControls(); });

  // 内容変更は再確認を求め、通信結果が不明な注文を自動・連続送信しない。
  $submit.on('click', async function () {
    if ($submit.prop('disabled') || busy || pending) return;
    busy = true;
    updateControls();
    message($submitStatus, '注文内容を確認しています。');
    let nextCart;
    try { nextCart = await store.cart(); }
    catch (xhr) {
      readFailure(xhr);
      message($submitStatus, '注文は送信していません。買い物袋を再読み込みしてください。', true);
      busy = false;
      updateControls();
      return;
    }
    const changed = orderCartSignature(cart) !== orderCartSignature(nextCart);
    render(nextCart);
    if (changed || cartError(cart)) {
      message($submitStatus, changed ? '商品・数量・金額が変わりました。内容を確認してから、もう一度注文ボタンを押してください。' : '買い物袋の内容をご確認ください。', true);
      busy = false;
      updateControls();
      return;
    }
    setPending(true);
    message($submitStatus, '注文を送信しています。画面を閉じずにお待ちください。');
    try {
      const response = await store.checkout({
        billing_address: settings.billingAddress,
        shipping_address: settings.shippingAddress,
        payment_method: settings.paymentMethod,
        customer_note: $notes.val(),
        expected_total: cart.totals.total_price,
      });
      const url = checkoutResultUrl(response, settings, window.location.href);
      if (!url) {
        message($submitStatus, unknownResult, true);
        return;
      }
      setPending(false);
      window.location.assign(url);
    } catch (xhr) {
      if (xhr.status >= 400 && xhr.status < 500 && ![408, 429].includes(xhr.status)) {
        setPending(false);
        message($submitStatus, plain(xhr.responseJSON?.message) || '注文を受け付けられませんでした。内容をご確認ください。', true);
        try { render(await store.cart()); } catch (error) { readFailure(error); }
      } else message($submitStatus, unknownResult, true);
    } finally {
      busy = false;
      updateControls();
    }
  });
  // ブラウザーの「戻る」で古い注文ボタンを復元せず、現在のカートを読み直す。
  window.addEventListener('pageshow', function (event) { if (event.persisted) window.location.reload(); });
  if (pending) {
    message($status, unknownResult, true);
    updateControls();
  } else loadCart();
}
